import React from 'react';
//import {BsChevronLeft, BsChevronRight} from "react-icons/bs";
import '../index.css';
import '../events/events.css';
//import { Link } from "react-router-dom";

function TearoomAd() {
  /*<div className="ffdRow">
        <div className="eventCol">
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "LFCF_poster2a.png"}
            alt="Johnny Cash event"
          ></img>
        </div>
      </div>*/

  /*<div className="eventCol">
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "1.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "2.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>
          <img
            className="eventImg"
            style={{ marginBottom: "0px" }}
            src={process.env.PUBLIC_URL + "/events/" + "3.jpg"}
            alt="Jingle Bell Tea Service"
          ></img>

          <div style={{ background: "green", color: "white" }}>
            <p className="teaBooking">
              Please advise requested seating time(s) and number of people. The
              tearoom manager will reach out to you to confirm your reservation.
              Reservations are not guaranteed until you receive confirmation.
            </p>
            <p className="teaBooking">$34.99 per person / $32.99 per Senior</p>
            */

  return (
    <div className="">
      <div className="ffdRow2">
        <div style={{ fontColor: 'white', marginTop: '-15px' }} className="">
          <img
            className="container1"
            src={process.env.PUBLIC_URL + '/events/' + 'teamanagerv2.png'}
            alt="Country Fest"
          ></img>
        </div>
        <div className="tearoomContact">
          <p>To apply email resume to londonhf@telus.net</p>
        </div>
      </div>
    </div>
  );
}

export default TearoomAd;
